import { useT } from '@/i18n'
import { workflowMessages } from '@/i18n/messages/workflow'

export type WfT = ReturnType<typeof useWfT>
export function useWfT() { return useT(workflowMessages) }

type Key = keyof typeof workflowMessages.en
/** Role, gate and item names are keyed by the API's codes. */
export const roleLabel = (t: WfT, role: string) => t(`role_${role}` as Key)
export const gateLabel = (t: WfT, state: string) => t(`gate_${state}` as Key)
export const itemLabel = (t: WfT, gate: string, item: string) => t(`item_${gate}_${item}` as Key)
